import _ from 'underscore'
import FormView from './form'
import LoginViewTemplate from '../templates/login.tpl'
import user from '../user'
import config from '../config'
import messages from '../messages'
import Alert from '../helpers/alert'
import Backbone from 'backbone'

const LoginView = FormView.extend({
    events: {
        'click .close': 'close',
        'click .submit': 'login',
        'click .forgotten': 'forgottenPassword',
        'click .register': 'register',
    },
    initialize() {
        this.template = _.template(LoginViewTemplate)
    },
    login() {
        if (user.get('loading')) return

        const username = this.$el.find('#username').val()
        const password = this.$el.find('#password').val()

        new Promise((resolve, reject) => {
            if (username.trim() === '') {
                reject(messages.MSG_USERNAME_BLANK)
            }
            if (password.trim() === '') {
                reject(messages.MSG_PASSWORD_BLANK)
            }
            resolve()
        })
            .then(() => user.login(username, password))
            .then(() => this.close())
            .catch((error) => {
                user.set('loading', false)

                // pass error to next catch
                throw error
            })
            .catch(Alert)
    },
    forgottenPassword() {
        Backbone.history.navigate('forgotten-password', { trigger: true })
    },
    register() {
        Backbone.history.navigate('register', { trigger: true })
    },
    close() {
        const returnRoute = config.get('returnRoute')
        config.unset('returnRoute')
        Backbone.history.navigate(returnRoute || '', { trigger: true })
    }
})

export default LoginView